export default "__VITE_ASSET__ffba2764__"